import {
  CircularProgress,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { formatDate } from "libs/utils/format";
import { get, pick } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPersonal,
  addPersonalSlice,
  selectAddPersonal,
} from "redux/modules/addPersonalSlice";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPassportState } from "redux/modules/passportSlice";
import {
  addPersonalReference,
  selectPersonalDetail,
} from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  checkSmartO,
  checkSmartOSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCheckSmartO,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

const TextField = React.memo(MUITextField);

export default function UserProfileStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const passportState = useSelector(selectPassportState);
  const personalDetail = useSelector(selectPersonalDetail);
  const addPersonalState = useSelector(selectAddPersonal);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const smartform = useSelector(selectCurrentSmartForm);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const checkSmartOState = useSelector(selectCheckSmartO);

  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const relationshipConfig = get(masterData, "relationshipConfig", []);
  const smartservice = get(masterData, "smartservice", []);
  const personalId = get(personalDetail, "personalID", "");
  const ocrFirstName = get(passportState, "detail.firstName", "");
  const ocrLastName = get(passportState, "detail.lastName", "");

  const personal = pick(get(smartform, "personal", {}), [
    "personalID",
    "firstname",
    "middleName",
    "lastName",
    "nationalityID",
    "birthDate",
    "email",
    "placeOfBirth",
    "gender",
    "passportNumber",
    "dateofIssue",
    "validuntil",
    "visatypeID",
  ]);
  const detailList = [
    "Marittal",
    "AddressInHome",
    "PhoneNumber",
    "Email",
    "accompanyFistName",
    "accompanyMiddleName",
    "accompanyLastname",
    "accompanyRelationship",
    "accompanyTypeSmartVisa",
    "ContactMobile",
    "ContactEmail",
    "SmartfromMainNo",
    "accompanyID",
  ];

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part A")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce((p, c) => ({ ...p, [c.smartName]: c }), {});

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        CountryConfig: true,
        relationshipConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalDetail, personalId, smartServiceId]);

  useEffect(() => {
    if (!addPersonalState.isLoading) {
      if (addPersonalState.isSuccess) {
        dispatch(addPersonalSlice.actions.clearAsyncState());
      } else if (addPersonalState.isFailure) {
        hideLoading();
        alert(addPersonalState.error?.message);
        dispatch(addPersonalSlice.actions.clearAsyncState());
      }
    }
  }, [addPersonalState, dispatch, hideLoading]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const validationSchema = yup.object({
    // personal: yup.object({
    //   personalID: yup.string(),
    //   fistName: yup.string().required("Fist name is a required field"),
    //   middleName: yup.string(),
    //   lastName: yup.string().required("Last name is a required field"),
    //   nationalityID: yup.string().required("Nationality is a required field"),
    //   birthDate: yup.string().required("Birthdate is a required field"),
    //   email: yup.string().required("Email is a required field"),
    //   placeOfBirth: yup.string().required("Placeofbirth is a required field"),
    //   gender: yup.string().required("Gender is a required field"),
    //   passportNumber: yup
    //     .string()
    //     .required("Passportnumber is a required field"),
    //   dateofIssue: yup.string().required("Date of issue is a required field"),
    //   validuntil: yup.string().required("Valid until is a required field"),
    // }),
    document: yup.object({
      //   Marittal: yup.string().required("Marittal is a required field"),
      //   AddressInHome: yup
      //     .string()
      //     .required("Address in home is a required field"),
      //   PhoneNumber: yup.string().required("PhoneNumber is a required field"),
      //   Email: yup.string().required("Email is a required field"),
      SmartfromMainNo: yup
        .string()
        .required("Document no. is a required field"),
      accompanyFistName: yup.string().required("Fist name is a required field"),
      //   accompanyMiddleName: yup.string(),
      accompanyLastname: yup.string().required("Last name is a required field"),
      //   accompanyRelationship: yup.string(),
      //   accompanyTypeSmartVisa: yup.string(),
      //   ContactMobile: yup.string(),
      //   ContactEmail: yup.string().email(),
    }),
  });

  const callAPISubmit = async (values) => {
    showLoading();

    const documentFields = Object.keys(values.document);
    const getFieldListConfig = defaultType
      .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        default:
          return get(values, `document.${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null, // get(smartform, "survey", null), // TODO wait for support case edit
      visaissuance: null, // get(smartform, "visaissuance", null), // TODO wait for support case edit
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addPersonal({
        ...values.personal,
        visatypeID: null,
      })
    );
    await dispatch(
      addPersonalReference({
        referenceID: null,
        personalID: checkSmartOState.data?.personalID,
        refpersonalID: personalId,
      })
    );
    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        personalID: get(personal, "personalID", ""),
        fistName: get(personal, "firstname", "") || ocrFirstName,
        middleName: get(personal, "middleName", "") || "",
        lastName: get(personal, "lastName", "") || ocrLastName,
        nationalityID: get(personal, "nationalityID", "") || "",
        birthDate: formatDate(get(personal, "birthDate", "") || ""),
        email: get(personal, "email", "") || "",
        placeOfBirth: get(personal, "placeOfBirth", "") || "",
        gender: get(personal, "gender", "M") || "M",
        passportNumber: get(personal, "passportNumber", "") || "",
        dateofIssue: formatDate(get(personal, "dateofIssue", "") || ""),
        validuntil: formatDate(get(personal, "validuntil", "") || ""),
        visatypeID: null,
      },
      document: {
        Marittal: get(detail, "Marittal.value", "S"),
        AddressInHome: get(detail, "AddressInHome.value", ""),
        PhoneNumber: get(detail, "PhoneNumber.value", ""),
        Email: get(detail, "Email.value", ""),
        SmartfromMainNo: get(detail, "SmartfromMainNo.value", ""),
        accompanyFistName: get(detail, "accompanyFistName.value", ""),
        accompanyMiddleName: get(detail, "accompanyMiddleName.value", ""),
        accompanyLastname: get(detail, "accompanyLastname.value", ""),
        accompanyRelationship: get(detail, "accompanyRelationship.value", ""),
        accompanyTypeSmartVisa: get(detail, "accompanyTypeSmartVisa.value", ""),
        ContactMobile: get(detail, "ContactMobile.value", ""),
        ContactEmail: get(detail, "ContactEmail.value", ""),
        accompanyID: get(detail, "accompanyID.value", false),
      },
    },
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  useEffect(() => {
    if (!checkSmartOState.isLoading) {
      if (checkSmartOState.isSuccess) {
        dispatch(checkSmartOSlice.actions.clearAsyncState());
        if (!checkSmartOState.data?.isValid) {
          formik.setFieldError(
            "document.SmartfromMainNo",
            "Holder or applicant not found."
          );
          formik.setFieldValue("document.accompanyID", false);
        } else {
          formik.setFieldValue("document.accompanyID", true);
        }
      } else if (checkSmartOState.isFailure) {
        alert(checkSmartOState.error?.message);
        dispatch(checkSmartOSlice.actions.clearAsyncState());
        formik.setFieldValue("document.accompanyID", false);
      }
    }
  }, [checkSmartOState, dispatch]);

  const isError = (fieldName) =>
    get(formik.touched, fieldName, "") &&
    Boolean(get(formik.errors, fieldName, ""));

  const getErrorMessage = (fieldName) =>
    get(formik.touched, fieldName, "")
      ? get(formik.errors, fieldName, "") || " "
      : " ";

  const handleClickCheckHolder = async () => {
    const SmartNo = formik.values.document?.SmartfromMainNo ?? "";
    const Firstname = formik.values.document?.accompanyFistName ?? "";
    const Lastname = formik.values.document?.accompanyLastname ?? "";

    await formik.setFieldTouched("document.SmartfromMainNo");
    await formik.setFieldTouched("document.accompanyFistName");
    await formik.setFieldTouched("document.accompanyLastname");

    await formik.setTouched({
      "document.SmartfromMainNo": true,
      "document.accompanyFistName": true,
      "document.accompanyLastname": true,
    });

    if (SmartNo && Firstname && Lastname) {
      dispatch(
        checkSmartO({
          SmartNo,
          Firstname,
          Lastname,
        })
      );
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Application Form"
        subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “O”"
      />
      <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part A : Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div>
                      <Typography>Full English name as in passport</Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>First name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="personal.fistName"
                        value={formik.values.personal.fistName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.fistName")}
                        helperText={getErrorMessage("personal.fistName")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Middle name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="personal.middleName"
                        value={formik.values.personal.middleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.middleName")}
                        helperText={getErrorMessage("personal.middleName")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Last name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="personal.lastName"
                        value={formik.values.personal.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.lastName")}
                        helperText={getErrorMessage("personal.lastName")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Current Nationality / Nationality at birth, if different
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        // style={{ width: 200 }}
                        error={isError("personal.nationalityID")}
                      >
                        <InputLabel>Selected your nationality</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected your nationality"
                          name="personal.nationalityID"
                          value={formik.values.personal.nationalityID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {nationalityConfig.map((nationality) => (
                            <MenuItem
                              value={nationality.nationalityID}
                              key={nationality.nationalityID}
                            >
                              {nationality.nationalityName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("personal.nationalityID")}
                        >
                          {getErrorMessage("personal.nationalityID")}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>Date of birth ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        disabled={!canEdit}
                        // style={{ width: 200 }}
                        className={classes.formControl}
                        inputVariant="outlined"
                        disableFuture
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Date of birth"
                        views={["year", "month", "date"]}
                        name={`personal.birthDate`}
                        value={
                          get(formik.values, `personal.birthDate`, null) || null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.birthDate`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.birthDate`)}
                        helperText={getErrorMessage(`personal.birthDate`)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Place of birth ( city, province/state, country )
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="personal.placeOfBirth"
                        value={formik.values.personal.placeOfBirth}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.placeOfBirth")}
                        helperText={getErrorMessage("personal.placeOfBirth")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>Gender</InputLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="personal.gender"
                              value="M"
                              checked={formik.values.personal.gender === "M"}
                              onClick={() => {
                                formik.setFieldValue("personal.gender", "M");
                              }}
                            />
                          }
                          label="Male"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="personal.gender"
                              value="F"
                              checked={formik.values.personal.gender === "F"}
                              onClick={() => {
                                formik.setFieldValue("personal.gender", "F");
                              }}
                            />
                          }
                          label="Female"
                        />
                      </FormGroup>
                      <FormHelperText error={isError("personal.gender")}>
                        {getErrorMessage("personal.gender")}
                      </FormHelperText>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>Marital status</InputLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="Single"
                              value="S"
                              checked={formik.values.document.Marittal === "S"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "S");
                              }}
                            />
                          }
                          label="Single"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="Married"
                              value="M"
                              checked={formik.values.document.Marittal === "M"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "M");
                              }}
                            />
                          }
                          label="Married"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="Divorced"
                              value="D"
                              checked={formik.values.document.Marittal === "D"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "D");
                              }}
                            />
                          }
                          label="Divorced"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="Window"
                              value="W"
                              checked={formik.values.document.Marittal === "W"}
                              onClick={() => {
                                formik.setFieldValue("document.Marittal", "W");
                              }}
                            />
                          }
                          label="Window"
                        />
                      </FormGroup>
                      <FormHelperText error={isError("document.Marittal")}>
                        {getErrorMessage("document.Marittal")}
                      </FormHelperText>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>Passport number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="personal.passportNumber"
                        value={formik.values.personal.passportNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("personal.passportNumber")}
                        helperText={getErrorMessage("personal.passportNumber")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>Date of issue ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        disabled={!canEdit}
                        // style={{ width: 200 }}
                        className={classes.formControl}
                        inputVariant="outlined"
                        disableFuture
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Date of issue"
                        views={["year", "month", "date"]}
                        name={`personal.dateofIssue`}
                        value={
                          get(formik.values, `personal.dateofIssue`, null) ||
                          null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.dateofIssue`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.dateofIssue`)}
                        helperText={getErrorMessage(`personal.dateofIssue`)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
                      <DatePicker
                        disabled={!canEdit}
                        className={classes.formControl}
                        // style={{ width: 200 }}
                        inputVariant="outlined"
                        disableFuture
                        openTo="year"
                        format="DD-MM-YYYY"
                        label="Valid until"
                        views={["year", "month", "date"]}
                        name={`personal.validuntil`}
                        value={
                          get(formik.values, `personal.validuntil`, null) ||
                          null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personal.validuntil`,
                            date.format("YYYY-MM-DD")
                          );
                        }}
                        error={isError(`personal.validuntil`)}
                        helperText={getErrorMessage(`personal.validuntil`)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <InputLabel>Address in home</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.AddressInHome"
                        value={formik.values.document.AddressInHome}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.AddressInHome")}
                        helperText={getErrorMessage("document.AddressInHome")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div className={classes.wrapField}>
                      <InputLabel>Home / mobile phone number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.PhoneNumber"
                        value={formik.values.document.PhoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.PhoneNumber")}
                        helperText={getErrorMessage("document.PhoneNumber")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.Email"
                        value={formik.values.document.Email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.Email")}
                        helperText={getErrorMessage("document.Email")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={13} />
                    <div className={classes.wrapField}>
                      <InputLabel>{`Please specify the name of  Smart Visa " T', "E", "I" or "S" holder or applicant whom you will accompany`}</InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Document no.</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.SmartfromMainNo"
                        value={formik.values.document.SmartfromMainNo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.SmartfromMainNo")}
                        helperText={getErrorMessage("document.SmartfromMainNo")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>First name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.accompanyFistName"
                        value={formik.values.document.accompanyFistName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.accompanyFistName")}
                        helperText={getErrorMessage(
                          "document.accompanyFistName"
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Middle name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.accompanyMiddleName"
                        value={formik.values.document.accompanyMiddleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.accompanyMiddleName")}
                        helperText={getErrorMessage(
                          "document.accompanyMiddleName"
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Last name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.accompanyLastname"
                        value={formik.values.document.accompanyLastname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.accompanyLastname")}
                        helperText={getErrorMessage(
                          "document.accompanyLastname"
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Type of his/her Smart Visa</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError(
                          "document.accompanyTypeSmartVisa",
                          formik
                        )}
                      >
                        <InputLabel>
                          Selected Type of his/her Smart Visa
                        </InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected Type of his/her Smart Visa"
                          name="document.accompanyTypeSmartVisa"
                          value={formik.values.document.accompanyTypeSmartVisa}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {smartservice.map((service) => (
                            <MenuItem
                              value={service.smartserviceId}
                              key={service.smartserviceId}
                            >
                              {service.smartserviceName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError(
                            "document.accompanyTypeSmartVisa",
                            formik
                          )}
                        >
                          {getErrorMessage(
                            "document.accompanyTypeSmartVisa",
                            formik
                          )}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Relationship with the main Smart Visa holder/applicant.
                      </InputLabel>
                      <FormGroup row>
                        {relationshipConfig.map((relationship) => (
                          <FormControlLabel
                            key={relationship.relationshipID}
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name={relationship.relationshipName}
                                value={relationship.relationshipID}
                                checked={
                                  formik.values.document
                                    ?.accompanyRelationship ===
                                  relationship.relationshipID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "document.accompanyRelationship",
                                    relationship.relationshipID
                                  );
                                }}
                              />
                            }
                            label={relationship.relationshipName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Mobile phone number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactMobile"
                        value={formik.values.document.ContactMobile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactMobile")}
                        helperText={getErrorMessage("document.ContactMobile")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.ContactEmail"
                        value={formik.values.document.ContactEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ContactEmail")}
                        helperText={getErrorMessage("document.ContactEmail")}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            marginTop: 44,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <ColorButton
            disabled={!canEdit}
            style={{ height: 40, marginLeft: 20 }}
            variant="contained"
            color={
              checkSmartOState.isLoading
                ? "warning"
                : formik.values.document.accompanyID
                  ? "success"
                  : "error"
            }
            onClick={() => {
              if (!checkSmartOState.isLoading) {
                handleClickCheckHolder();
              }
            }}
          >
            {checkSmartOState.isLoading ? (
              <>
                <CircularProgress
                  size={16}
                  style={{ marginRight: 8, color: "inherit" }}
                />{" "}
                Checking...
              </>
            ) : formik.values.document.accompanyID ? (
              "Found the holder or applicant"
            ) : (
              "Check holder or applicant"
            )}
          </ColorButton>
        </div>
        <ButtonController
          isDisabledNextButton={
            !formik.values.document.accompanyID || checkSmartOState.isLoading
          }
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
